module.exports = __webpack_public_path__ + "6663.725334b92355b210eea1.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/TechTeam/Desktop/deploy/sims-web-prod/src/assets/img/6663.svg
// module id = ../../../../../src/assets/img/6663.svg
// module chunks = main